import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ModernRecipeForm } from './ModernRecipeForm';
import { recipesService } from '../services/recipesService';
import { Recipe } from 'public-contracts';

export const ModernRecipeFormPage: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [recipe, setRecipe] = useState<Recipe | null>(null);
  const [loading, setLoading] = useState(!!id);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (id) {
      // Load recipe for editing
      console.log('Loading recipe with ID:', id);
      setLoading(true);
      setError(null);
      recipesService
        .getRecipe(id)
        .then((data) => {
          console.log('Recipe loaded successfully:', data);
          if (!data || !data.id) {
            throw new Error('Invalid recipe data received');
          }
          setRecipe(data);
          setLoading(false);
        })
        .catch((err) => {
          console.error('Failed to load recipe:', err);
          console.error('Error details:', {
            message: err instanceof Error ? err.message : String(err),
            stack: err instanceof Error ? err.stack : undefined,
          });
          const errorMessage = err instanceof Error ? err.message : 'Failed to load recipe';
          setError(errorMessage);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [id]);

  const handleClose = () => {
    navigate('/recipes');
  };

  const handleSave = (savedRecipe: Recipe) => {
    navigate('/recipes');
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
        <span className="ml-2">Loading recipe...</span>
      </div>
    );
  }

  if (id && !loading && !recipe) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-red-600 mb-2">
            Recipe not found
          </h2>
          <p className="text-gray-600 mb-2">
            The recipe with ID {id} could not be loaded.
          </p>
          {error && (
            <p className="text-sm text-red-500 mb-4">
              Error: {error}
            </p>
          )}
          <button
            onClick={handleClose}
            className="px-4 py-2 bg-primary text-white rounded hover:bg-primary/90"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-6">
      <ModernRecipeForm
        open={true}
        onClose={handleClose}
        onSave={handleSave}
        recipe={recipe}
      />
    </div>
  );
};

